import AppSDK from "@growthos/ui-app-sdk";

const TWENTY_MINUTES = 60 * 1000 * 20;

export const fetchWithAuthGet = (url, parameters = {}) => {
	const contextId = AppSDK.getContextId();
	const urlWithContextId = url + (contextId ? `${url.includes("?") ? "&" : "?"}contextID=${contextId}` : "");

	return AppSDK.fetchMultiCloud(urlWithContextId, {
		method: "GET",
		responseType: "json",
		timeout: TWENTY_MINUTES,
		...parameters
	}).then((response) => {
		let includesJson = false;
		for (const header of response.headers.entries()) {
			if (header[0] === "content-type" && header[1].includes("application/json")) {
				includesJson = true;
			}
		}
		return includesJson ? response.json() : Promise.resolve(response);
	});
};

export const fetchWithAuthPost = (url, postData = null, parameters = {}) => {
	const contextId = AppSDK.getContextId();
	const urlWithContextId = url + (contextId ? `${url.includes("?") ? "&" : "?"}contextID=${contextId}` : "");

	return AppSDK.fetchMultiCloud(urlWithContextId, {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		},
		timeout: TWENTY_MINUTES,
		body: postData,
		...parameters
	}).then((response) => {
		let includesJson = false;
		for (const header of response.headers.entries()) {
			if (header[0] === "content-type" && header[1].includes("application/json")) {
				includesJson = true;
			}
		}
		return includesJson ? response.json() : Promise.resolve(response);
	});
};

export const fetchWithAuthPut = (url, postData = null, parameters = {}) => {
	const contextId = AppSDK.getContextId();
	const urlWithContextId = url + (contextId ? `${url.includes("?") ? "&" : "?"}contextID=${contextId}` : "");

	return AppSDK.fetchMultiCloud(urlWithContextId, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json"
		},
		body: postData,
		timeout: TWENTY_MINUTES,
		...parameters
	}).then((response) => {
		let includesJson = false;
		for (const header of response.headers.entries()) {
			if (header[0] === "content-type" && header[1].includes("application/json")) {
				includesJson = true;
			}
		}
		return includesJson ? response.json() : Promise.resolve(response);
	});
};
